import ItnAPI from './_integrationApi.js';
import commonFn from '@/commons/commonFunction';
import httpClient from '@/apis/base/httpclient';

class IntegrationMeInvoiceApi extends ItnAPI {
  constructor() {
    super();
  }
  controllerName = 'MeInvoices';

  /**
   * Kiểm tra xem đơn vị đã kết nối với hệ thống meInvoice chưa
   * @returns
   * npcuong 07.09.2022
   */
  checkConnectMeInvoice() {
    let request = {
      url: this.getAPIUrl() + '/CheckConnectMeInvoice',
    };
    return this.getAsync(request);
  }

  /**
   * Chức năng xem báo cáo
   * @returns
   * NMDUC1 27/09/2022
   */
  viewReportMeInvoice(transactionID, invoice_type) {
    let request = {
      url: this.getAPIUrl() + '/View/' + transactionID + '/' + invoice_type,
    };

    return this.getAsync(request);
  }

    /**
   * Tải file pdf từ invoice
   * @returns
   * ptthuy2 27.11.2023
   */
     downloadInvoicePDF(transactionID) {
      let request = {
        url: this.getAPIUrl() + '/downloadinvoicepdf/' + transactionID,
      };
  
      return this.getAsync(request);
    }

  /**
   * Chức năng tải hàng loạt báo cáo
   * @returns
   * NMDUC1 27/09/2022
   */
  DownloadReportAllMeInvoice(transactionIDList) {
    let request = {
      url: this.getAPIUrl() + '/DownloadAll',
      data: transactionIDList,
    };

    return this.postAsync(request);
  }

  /**
   * Chức năng xem hàng loạt báo cáo
   * @returns
   * NMDUC1 27/09/2022
   */
  viewReportAllMeInvoice(transactionIDList, invoice_type) {
    let x = transactionIDList.join(',');

    let request = {
      url: this.getAPIUrl() + '/ViewAll',
      data: {
        transactionID: x,
        invoice_type: invoice_type,
      },
    };

    return this.postAsync(request);
  }

  /**
   * Chuyển thành hóa đơn giấy
   * @returns
   * NMDUC1 30/09/2022
   */
  convertToPaperVoucher(voucherPaper, invoice_type) {
    let request = {
      url: this.getAPIUrl() + '/Convert?invoice_type=' + invoice_type,
      data: voucherPaper,
    };

    return this.postAsync(request);
  }

  /**
   * Chức năng tải báo cáo
   * @returns
   * NMDUC1 27/09/2022
   */
  downloadReportMeInvoice(transactionID, invoice_type) {
    let request = {
      url: this.getAPIUrl() + '/Download/' + transactionID + '/' + invoice_type,
    };

    return this.getAsync(request);
  }

  /**
   * Xử lý kết nối tới hệ thống meInvoice
   * @param {*} loginModel
   * @returns
   * npcuong 06.09.2022
   */
  connectMeInvoice(loginModel) {
    let request = {
      url: this.getAPIUrl() + '/Connect',
      data: loginModel,
    };
    return this.postAsync(request);
  }

  /**
   * Xử lý xác thực hai lớp
   * @param {*} taxCode
   * @returns
   * npcuong 12.09.2022
   */
  twoFactorAuthorize(loginModel) {
    let request = {
      url: this.getAPIUrl() + '/TwoFactorAuthorize',
      data: loginModel,
    };
    return this.postAsync(request);
  }

  /**
   * Xử lý hủy kết nối đến hệ thống meInvoice
   * @returns
   * npcuong 07.09.2022
   */
  disconnectMeInvoice() {
    let request = {
      url: this.getAPIUrl() + '/Disconnect',
    };
    return this.postAsync(request);
  }

  /**
   * Lấy về trạng thái chấp nhận thỏa thuận sử dụng của đơn vị
   * @param {*} taxCode Mã số thuế của đơn vị
   * npcuong 06.09.2022
   */
  getStatusAgreement(taxCode) {
    const url = this.getAPIUrl() + '/GetStatusAgreement';
    const data = { taxCode };
    const request = { url, data };
    return this.getAsync(request);
  }

  /**
   * Lấy về thỏa thuận sử dụng hiện tại của một đơn vị
   * @param {*} taxCode Mã số thuế của đơn vị
   * npcuong 12.09.2022
   */
  getCurrentAgreement() {
    const url = this.getAPIUrl() + '/GetCurrentAgreement';
    const data = null;
    const request = { url, data };
    return this.getAsync(request);
  }

  /**
   * Lấy về bước hiện tại đang thiết lập
   * @param {*} taxCode Mã số thuế của đơn vị
   * @returns
   * npcuong 08.09.2022
   */
  getDashboardInfo(taxCode) {
    const url = this.getAPIUrl() + '/GetDashboardInfo';
    const data = { taxCode };
    const request = { url, data };

    return this.getAsync(request);
  }

  /**
   * Lấy về thông tin đơn vị kết nối với meInvoice
   * @param {*} taxCode Mã số thuế của đơn vị
   * @returns
   * npcuong 09.09.2022
   */
  getCompanyInfo(taxCode) {
    const url = this.getAPIUrl() + '/GetCompanyInfo';
    const data = { taxCode };
    const request = { url, data };

    return this.getAsync(request);
  }

  /**
   * Lấy dữ liệu từ bên meInvoice
   * @param {*} taxCode
   * @returns
   * tvhien 16.09.2022
   * DVMINH bổ sung toDate - đến thời điểm nào
   */
  getDataInvoice(taxCode, fromDate, toDate, isGetTicket = false) {
    const url = this.getAPIUrl() + '/getDataInvoice';
    const data = { tax_code: taxCode, from_date: fromDate , to_date: toDate, is_get_ticket: isGetTicket};
    const request = { url, data };

    return this.getAsync(request);
  }

  /**
   * Lấy danh sách biên lai từ meinvoice
   * tvhien 08/04/2022
   * DVMINH 4/4/2024 Bổ sung khoảng thời gian load dữ liệu
   */
  getSAReceipt(taxCode, fromDate, toDate) {
    const url = this.getAPIUrl() + '/GetDataReceipt';
    const data = { tax_code: taxCode, from_date: fromDate, to_date: toDate };
    const request = { url, data };

    return this.getAsync(request);
  }

  /**
   * Lấy danh sách mẫu hóa đơn
   * @param {*} taxCode
   * @returns
   * tvhien 20.09.2022
   */
  getInvoiceTemplateForPublish(payload, taxCode, invoice_type, year) {
    const url =
      this.getAPIUrl() + '/GetInvoiceTemplate?tax_code=' + taxCode + '&invoice_type=' + invoice_type + '&year=' + year;

    const request = { url };

    return this.getAsync(request);
  }

  /**
   * Lấy thông tin thiết lập gửi email
   * @param {*} taxCode
   * @returns
   * TTLONG 19/09/2022
   */
  getSetupEmail(taxCode) {
    const url = this.getAPIUrl() + '/GetSetupEmail';
    const data = { taxCode };
    const request = { url, data };

    return this.getAsync(request);
  }

  /**
   * Gửi hóa đơn cho KH
   * @param {*} payload
   * @returns
   * TTLONG 19/09/2022
   */
  sendInvocieEmail(payload) {
    const url = this.getAPIUrl() + '/SendInvoiceEmail';
    const data = payload;
    const request = { url, data };

    return this.postAsync(request);
  }

  /**
   * Hủy hóa đơn
   * @param {*} payload
   * @returns
   * TTLONG 22/09/2022
   */
  updateCancelInvoice(payload) {
    const url = this.getAPIUrl() + `/UpdateCancelInvoice?taxCode=${payload.taxCode}`;
    const data = payload.sASaleInvoices;
    const request = { url, data };

    return this.putAsync(request);
  }

  /**
   * Cập nhật xác nhận đồng ý thỏa thuận sử dụng
   * npcuong 13.09.2022
   */
  updateAcceptAgreement(taxCode) {
    let request = {
      url: this.getAPIUrl() + '/UpdateAcceptAgreement',
      data: { taxCode },
    };
    return this.postAsync(request);
  }

  // /**
  //  * Thực hiện cập nhật đã show hướng dẫn bắt đầu sử dụng của đơn vị chưa
  //  * @param {*} taxCode
  //  * npcuong 13.09.2022
  //  */
  // updateShowSetupGuide(taxCode) {
  //   let request = {
  //     url: this.getAPIUrl() + '/UpdateShowSetupGuide',
  //     data: {taxCode}
  //   };
  //   return this.postAsync(request);
  // }

  /**
   * Lấy về thông tin thiết lập của đơn vị với hệ thống meInvoice
   * @param {*} taxCode
   * @returns
   */
  getMeInvoiceSetupProcess(taxCode) {
    const url = this.getAPIUrl() + '/GetMeInvoiceSetupProcess';
    const data = { taxCode };
    const request = { url, data };
    return this.getAsync(request);
  }

  /**
   * Lấy ra ngày để validate
   * @param {*} payload
   * @returns
   * tvhien 27.09.2022
   */
  getInvoiceDateForPublish(payload) {
    const url = this.getAPIUrl() + '/getInvoiceDateForPublish';
    const data = payload;
    const request = { url, data };
    return this.postAsync(request);
  }

  /**
   * Thực hiện ký hóa đơn
   * @param {*} payload
   * @returns
   * tvhien 28.09.2022
   */
  signInvoiceESign(payload) {
    const url = this.getAPIUrl() + '/SignInvoiceSeriesESign';
    const data = payload;
    const request = { url, data };
    return this.postAsync(request);
  }

  /**
   * Lấy về thông tin tổng số hóa đơn
   * @param {*} payload
   * @returns
   * tvhien 28.09.2022
   */
  getDashboardInfo(taxCode) {
    const url = this.getAPIUrl() + '/GetDashboardInfo';
    const data = { taxCode };
    const request = { url, data };
    return this.getAsync(request);
  }

  /**
   * Lấy thông tin các bước thiết lập
   * @param {*} taxCode
   * @returns
   * tvhien 28.09.2022
   */
  getMeInvoiceSetupProcess(taxCode) {
    const url = this.getAPIUrl() + '/GetMeInvoiceSetupProcess';
    const data = { taxCode };
    const request = { url, data };
    return this.getAsync(request);
  }

  /**
   * Cập nhật hình thức hóa đơn sử dụng của đơn vị
   * @param {*} invoiceType
   * @returns
   * npcuong 13.10.2022
   */
  updateCompanyInvoiceType(isInvoiceWithCode) {
    const url = this.getAPIUrl() + '/UpdateCompanyInvoiceType';
    const data = { is_invoice_with_code: isInvoiceWithCode };
    const request = { url, data };
    return this.postAsync(request);
  }

  /**
   * Lấy hóa đơn dạng XML đã được hash để phục vụ kí số qua MISA KYSO
   * hàm này thực hiện trong luồng phát hành hóa đơn
   * @param {*} dataParam
   * @returns
   * nxhoa 29.9.2022
   */
  getInvoiceXmlHash(dataParam) {
    const url = this.getAPIUrl() + '/GetInvoiceXmlHash';
    const data = {
      Data: JSON.stringify(dataParam),
    };
    const request = { url, data };
    return this.postAsync(request);
  }

  /**
   * hàm thực hiện phát hành hóa đơn, thực hiện sau khi đã lấy được mẫu hóa đơn và kí số vào hóa đơn
   * @param {*} data
   * @returns
   * nxhoa 29.9.2022
   */
  publishInvoice(data) {
    const url = this.getAPIUrl() + '/PublishInvoice';
    const request = { url, data };
    return this.postAsync(request);
  }

  /**
   * Xem hóa đơn
   * @param {*} data
   * @returns
   * TTLONG 06.10.2022
   */
  previewInvoice(payload) {
    const url =
      this.getAPIUrl() +
      `/PreviewInvoice?taxCode=${payload.taxCode}&viewType=${payload.viewType}&publishType=${payload.publishType}&decreeType=${payload.decreeType}`;
    const request = { url, data: payload.data };
    return this.postAsync(request);
  }

  /**
   * xem biên lai
   * @param {*} payload 
   * @returns 
   * tvhien 10.04.2023
   */
  previewReceipt(payload) {
    const url = this.getAPIUrl() + `/PreviewReceipt?taxCode=${payload.taxCode}`;
    const request = { url, data: payload.data };
    return this.postAsync(request);
  }

  /**
   * kiểm tra xem đã đồng bộ xong chưa
   * @returns 
   * tvhien 01.11.2023
   */
  checkAsyncData(taxCode){
    let request = {
      url: this.getAPIUrl() + `/CheckAsyncData/${taxCode}`,
    };

    return this.getAsync(request);
  }
}
export default new IntegrationMeInvoiceApi();
